export default __webpack_public_path__ + "static/media/NTEX SYLLABUS_2026-27 CLASS 10.e1f3b9c4.pdf";